import { render, staticRenderFns } from "./BolsaAppAsideBar.vue?vue&type=template&id=7b42bd40&scoped=true"
import script from "./BolsaAppAsideBar.vue?vue&type=script&lang=js"
export * from "./BolsaAppAsideBar.vue?vue&type=script&lang=js"
import style0 from "./BolsaAppAsideBar.vue?vue&type=style&index=0&id=7b42bd40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b42bd40",
  null
  
)

export default component.exports